var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-box", style: _vm.videoStyle }, [
    _c("div", {
      ref: "video",
      staticClass: "video-wrap",
      domProps: { innerHTML: _vm._s(_vm.iframeEmbed) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }